import { render, staticRenderFns } from "./RfDataGridPop.vue?vue&type=template&id=2126f462&scoped=true"
import script from "./RfDataGridPop.vue?vue&type=script&lang=js"
export * from "./RfDataGridPop.vue?vue&type=script&lang=js"
import style0 from "./RfDataGridPop.vue?vue&type=style&index=0&id=2126f462&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126f462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2126f462')) {
      api.createRecord('2126f462', component.options)
    } else {
      api.reload('2126f462', component.options)
    }
    module.hot.accept("./RfDataGridPop.vue?vue&type=template&id=2126f462&scoped=true", function () {
      api.rerender('2126f462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/RfDataGridPop.vue"
export default component.exports